import styled from "styled-components/macro";

import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";
import { Border } from "Signups/FamilyRegistration/Shared/StyledComponents";

import FnrDragNDrop from "UI/FnrDragNDrop/FnrDragNDrop";
import FnrHoverButton from "UI/FnrHoverButton/FnrHoverButton";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrStatusIcon from "UI/FnrStatusIcon/FnrStatusIcon";

import AdditionalInfoListItem from "./AdditionalInfoListItem";

const SBorder = styled(Border)`
  padding: 4px;
  position: relative;
`;

const HelpText = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #5d7479;
  margin-bottom: 12px;
  padding: 0 6px;
  padding-top: 12px;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  @media screen and (min-width: 841px) {
    max-height: calc(100vh - 160px);
  }
`;
const Inside = styled.div`
  max-width: 560px;
`;

const AddNewFieldButton = styled.div`
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

const AddNewFieldButtonContainer = styled.div`
  padding: 2px;
  &:not(:first-child) {
    padding-top: 4px;
  }
  overflow: hidden; /* fixes a scrollbar flicker */
`;

const NavWithModal = () => {
  const fieldsOnItem = extendedFieldHooks.useFieldDragItems();
  const [isLoadingOrder, updateExtendedFieldOrder] =
    extendedFieldHooks.useUpdateExtendedFieldOrder();
  const clearSelection = extendedFieldHooks.useClearSelection({
    modalShouldClear: true,
  });
  const [, setIsNavigating] = extendedFieldHooks.useIsNavigating();
  const [isLoading] = extendedFieldHooks.useInitExtendedFields();

  const handleAddNewField = () => {
    clearSelection();
    setIsNavigating(false);
  };

  return (
    <Wrapper data-cy="ExtendedField_NavWithModal">
      <Inside>
        <HelpText>
          You can ask for members to fill out additional information when they
          sign up. Add or edit data you&apos;d like to collect below.
        </HelpText>
        <SBorder $variant="container">
          {fieldsOnItem?.length > 0 && (
            <FnrDragNDrop
              items={fieldsOnItem}
              itemIdName="networkFieldID"
              ItemComponent={AdditionalInfoListItem}
              onRelease={updateExtendedFieldOrder}
              disabled={isLoadingOrder}
              itemHasDragTrigger={true}
              noMargin
              staggered
            />
          )}
          <AddNewFieldButtonContainer>
            <FnrHoverButton
              borderRadius={6}
              bgColor="#eceff0"
              onClick={handleAddNewField}
            >
              <AddNewFieldButton>
                <FnrIcon far fa-plus-circle />
                <FnrTypography>Add a new field</FnrTypography>
              </AddNewFieldButton>
            </FnrHoverButton>
            <FnrStatusIcon isLoading={isLoading} fixToLowerRight />
          </AddNewFieldButtonContainer>
        </SBorder>
      </Inside>
    </Wrapper>
  );
};

export default NavWithModal;
